import { BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import { AppRoutes } from "./routes";
import { ToastContainer } from "./utils/toast";
import Header from "./components/Header";
import "./App.css";
import "./utils/toast.css";

function AppLayout() {
  const { pathname } = useLocation();
  const isUploadPage = /^\/upload-event-images(?:\/|$)/.test(pathname);
  return (
      <div className={`App${isUploadPage ? " App-camera" : ""}`}>
        {!isUploadPage && <Header />}
        <Routes>
          {/* All App Routes */}
          {AppRoutes}
        </Routes>
        {/* Global Toast Container */}
        <ToastContainer />
      </div>
  );
}

function App() {
  return <Router><AppLayout /></Router>;
}

export default App;
